import React, { useContext, useState } from "react";
import withAuth from "../utils/withAuth";
import { useNavigate } from "react-router-dom";
import styles from "../styles/home.module.css";
import IconButton from "@mui/material/IconButton";
import RestoreIcon from "@mui/icons-material/Restore";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { AuthContext } from "../contexts/AuthContext";

function HomeComponent() {
    let navigate = useNavigate();
    const [meetingCode, setMeetingCode] = useState("");

    const { addToUserHistory } = useContext(AuthContext);

    const generateRandomRoom = () => {
        return Math.random().toString(36).substring(2, 10);
    };

    const handleRandomRoom = async () => {
        const room = generateRandomRoom();
        await addToUserHistory(room);
        navigate(`/${room}`);
    };

    let handleJoinVideoCall = async () => {
        await addToUserHistory(meetingCode);
        navigate(`/${meetingCode}`);
    };
    return (
        <>
            <div className={styles.navBar}>
                <div className={styles.navLeft}>
                    <h2 className={styles.logo}>MeetMe</h2>
                </div>
                <div className={styles.navRight}>
                    <IconButton
                        onClick={() => {
                            navigate("/history");
                        }}
                    >
                        <RestoreIcon />
                        <span style={{ fontSize: "1.2rem" }}>History</span>
                    </IconButton>
                    <Button
                        onClick={() => {
                            localStorage.removeItem("token");
                            navigate("/auth");
                        }}
                    >
                        Logout
                    </Button>
                </div>
            </div>
            <div className={styles.meetContainer}>
                <div className={styles.leftPanel}>
                    <div>
                        <h1>Join a meeting</h1>
                        <p className={styles.subtitle}>
                            Enter a meeting code to start or join instantly
                        </p>
                        <div className={styles.inputBlock}>
                            <TextField
                                onChange={(e) => setMeetingCode(e.target.value)}
                                label="Meeting Code"
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                        <div className={styles.actionRow}>
                            <button
                                onClick={handleJoinVideoCall}
                                className={`${styles.actionBtn} ${styles.primary}`}
                            >
                                Join
                            </button>

                            <button
                                onClick={handleRandomRoom}
                                className={`${styles.actionBtn}  ${styles.secondary}`}
                            >
                                Random Room
                            </button>
                        </div>
                    </div>
                </div>
                <div className={styles.rightPanel}>
                    <img src="/logo3.png" alt="" />
                </div>
            </div>
        </>
    );
}

export default withAuth(HomeComponent);
